module.exports = __webpack_public_path__ + "img/Default-M-6.8dd5a2a1.svg";